import {Injectable, Inject} from '@angular/core';
import { TRANSLATIONS } from './translations';

@Injectable()
export class TranslateService {
  private _currentLang: string;

  public get currentLang() {
    return this._currentLang;
  }

  constructor(@Inject(TRANSLATIONS) private _translations: any) {}

  public use(lang: string): void {
    this._currentLang = lang;
  }

  private translate(key: string): string {
    let translation = key;

    if (this._translations[this._currentLang] && this._translations[this._currentLang][key]) {
      translation = this._translations[this._currentLang][key];
    }

    return translation;
  }

  public instant(key: string) {
    return this.translate(key);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/translate/translate.service.ts